import { Footprints, Car, Bike } from "lucide-react";

/**
 * CÓMO LLEGA EL VISITANTE — un solo sitio para las tres formas.
 *
 * El dato se guarda en inglés (`foot`, `vehicle`, `motorcycle`), como el resto
 * del modelo, y aquí se traduce. Está centralizado porque aparece en cinco
 * pantallas —el formulario, la lista del residente, la del guardia, el
 * resumen y la vista del visitante— y con la traducción repetida en cada una
 * bastaba con cambiar una palabra para que dejaran de coincidir.
 */

export const LLEGADAS = {
  foot: { etiqueta: "A pie", corta: "A pie", icono: Footprints },
  vehicle: { etiqueta: "En vehículo", corta: "Vehículo", icono: Car },
  motorcycle: { etiqueta: "En moto", corta: "Moto", icono: Bike },
};

/**
 * La forma de llegada de una visita, con respaldo.
 *
 * Las visitas creadas antes de que esto existiera no traen el campo. Se
 * asume «a pie», que es lo más probable y, sobre todo, lo que no inventa un
 * vehículo que nadie registró.
 */
export const llegadaDe = (visita) => LLEGADAS[visita?.arrivalMode] || LLEGADAS.foot;

/** `true` si la visita llega en algo, y por lo tanto puede tener placa. */
export const vieneEnVehiculo = (visita) =>
  visita?.arrivalMode === "vehicle" || visita?.arrivalMode === "motorcycle";

/**
 * Cómo llega, en una línea: «En vehículo · P123-456».
 *
 * Si no hay placa se devuelve sólo la forma. Una visita en vehículo sin placa
 * es posible —se creó antes de que el campo fuera obligatorio— y hay que
 * enseñarla como está, no fingir que no llegó en carro.
 */
export const resumenLlegada = (visita) => {
  const { etiqueta } = llegadaDe(visita);
  return visita?.plate ? `${etiqueta} · ${visita.plate}` : etiqueta;
};
